<div tabindex="-1"
     [tdWbFocus]="calendarFocus()"
     class="td-wb-date-picker-inner-container">
  <ng-content />
</div>
